<div class="home-container" qaInfiniteScroll (nearEnd)="onScroll()">
  <div class="home-contents">
    @if (auth.isLoggedIn()) {
    <div class="topbar-mobile-only">
      <mat-icon (click)="openSideBar()" class="menu-open-icon">menu</mat-icon>
    </div>
    }
    <span class="logo-container">
      <img
        [src]="auth.isLoggedIn() ? 'assets/logo.png' : 'assets/pre-login.png'"
        alt=""
      />
    </span>
    <div class="container">
      <div class="title find-content-title">
        {{ 'findContent.contentTitle' | translate }}
      </div>
      @if (auth.isLoggedIn()) {
      <div class="embed-button">
        <button mat-button (click)="embedHome()">
          <mat-icon>code</mat-icon>
          {{ 'content.course.actionMenu.embed' | translate }}
        </button>
      </div>
      }
      <qa-pin-input> </qa-pin-input>
      <div class="or-divider divider">
        <div class="left"></div>
        <div class="or">
          {{ 'findContent.or' | translate }}
        </div>
        <div class="right"></div>
      </div>
      <mat-form-field class="search-container m-top">
        <!-- <mat-icon matPrefix> search </mat-icon> -->
        <mat-label>
          {{ 'findContent.searchCourse' | translate }}
        </mat-label>
        <input
          [formControl]="courseSearchControl"
          autocomplete="off"
          matInput
          (keyup.enter)="searchEntity()"
          type="text"
          data-cy="searchEnity"
        />
        @if (courseSearchControl.value?.trim().length) {
        <button
          (click)="courseSearchControl.reset()"
          mat-icon-button
          matSuffix
          tabindex="-1"
          type="button"
        >
          <mat-icon>clear</mat-icon>
        </button>
        }
        <button
          (click)="searchEntity()"
          mat-icon-button
          matSuffix
          tabindex="-1"
          type="button"
          data-cy="searchBtn"
        >
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
      <div class="search-button m-top">
        <qa-button
          class="submit-btn"
          [isRaisedButton]="true"
          [label]="'findContent.courseSearchButton' | translate"
          (click)="searchEntity()"
        ></qa-button>
      </div>
    </div>
    <div class="download">
      {{ 'findContent.downloadApp' | translate }}
    </div>
    <div class="app-links m-top">
      <a [href]="appLinks.android" class="app-link" target="_blank">
        <img src="assets/images/play-store-badge.png" />
      </a>
      <a [href]="appLinks.apple" class="app-link" target="_blank">
        <img src="assets/images/app-store-badge.png" />
      </a>
    </div>
    <div [@courseCards]="courses?.length || -1" class="course-cards">
      @for (course of courses; track getCourseId($index, course)) {
      <a
        [routerLink]="['/course', course.pin_code]"
        class="course-card"
        matRipple
        data-cy="courseCard"
      >
        <div class="course-card-header" data-cy="courseCardHeader">
          <div class="course-card-title">
            {{ course.name }}
          </div>
          @if (course.is_password_protected) {
          <mat-icon
            matTooltip="{{
              'findContent.tooltip.passwordProtectedCourse' | translate
            }}"
          >
            lock
          </mat-icon>
          }
        </div>
        @if (course.responsible || course.organization?.name) {
        <div class="course-card-footer" data-cy="courseCardFooter">
          {{ course.responsible }}
          @if (course.responsible && course.organization?.name) { &mdash; }
          {{ course.organization?.name }}
        </div>
        }
      </a>
      } @if (loading) {
      <div class="loading-indicator"></div>
      }
    </div>
    @if (!auth.isLoggedIn() && !isWebClient) {
    <button class="link-to-login" (click)="jumpToLogin()">
      <div class="click-logo">
        <mat-icon>open_in_new</mat-icon>
      </div>
      <div class="text">
        <span class="top">Du bist Lehrkraft?</span>
        <span class="bottom">Hier geht's zum Login!</span>
      </div>
    </button>
    }
  </div>
</div>
